import { render, staticRenderFns } from "./POSModal.vue?vue&type=template&id=8b1dd998&scoped=true&"
import script from "./POSModal.vue?vue&type=script&lang=js&"
export * from "./POSModal.vue?vue&type=script&lang=js&"
import style0 from "./POSModal.vue?vue&type=style&index=0&id=8b1dd998&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1dd998",
  null
  
)

export default component.exports